import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../../../components/layout/AppLayout/AppLayout.jsx';
import StatsCards from '../components/StatsCards.jsx';
import { useInventoryStats } from '../hooks/useInventoryStats.js';
import '../InventoryManagement.css';

const InventoryDashboard = ({ onLogout }) => {
    const { t } = useTranslation(['inventory', 'common']);
    const navigate = useNavigate();
    const { stats, loading, error, setError } = useInventoryStats();

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    const inventoryModules = [
        {
            title: `📦 ${t('inventory:products')}`,
            description: t('inventory:productsDescription'),
            buttonText: t('inventory:manageProducts'),
            buttonClass: 'primary',
            onClick: () => navigate('/inventory/products')
        },
        {
            title: `📂 ${t('inventory:categories')}`,
            description: t('inventory:categoriesDescription'),
            buttonText: t('inventory:manageCategories'),
            buttonClass: 'success',
            onClick: () => navigate('/inventory/categories')
        },
        {
            title: `🏢 ${t('inventory:suppliers')}`,
            description: t('inventory:suppliersDescription'),
            buttonText: t('inventory:manageSuppliers'),
            buttonClass: 'info',
            onClick: () => navigate('/inventory/suppliers')
        },
        {
            title: `📋 ${t('inventory:movements')}`,
            description: t('inventory:movementsDescription'),
            buttonText: t('inventory:viewMovements'),
            buttonClass: 'purple',
            onClick: () => navigate('/inventory/movements')
        }
    ];

    return (
        <AppLayout 
            title={t('inventory:title')}
            error={error}
            setError={setError}
            onLogout={onLogout}
        >
            <div className="inventory-content">
                <StatsCards stats={stats} />
                
                <div className="modules-grid">
                    {inventoryModules.map((module, index) => (
                        <div key={index} className="module-card">
                            <h3 className="module-title">
                                {module.title}
                            </h3>
                            <p className="module-description">
                                {module.description}
                            </p>
                            <button 
                                onClick={module.onClick}
                                className={`module-button ${module.buttonClass}`}
                            >
                                {module.buttonText}
                            </button>
                        </div>
                    ))}
                </div>


            </div>
        </AppLayout>
    );
};

export default InventoryDashboard;